import React from "react";
import CapEditableTable from "./CapEditableTable";
import EditableTable from "./EditableTable";
import { useFetchInventoryQuery } from "features/store";
import { TableTitleStyles } from "./Inventory.style";
import { useState } from "react";
import { useFetchInventoryFilterOptionsQuery } from "features/store";

const CapMaterialsTable = ({ pagination, onPaginationChange, onActivityLogClick }) => {
  const currentPage = pagination?.current || 1;
  const pageSize = pagination?.pageSize || 10;

  const [serverFilters, setServerFilters] = useState({
    cap_material: null,
    sub_type: null,
    color: null,
  });

  const { data: dataSource, isLoading: loading } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    page: currentPage,
    page_size: pageSize,
    ...(serverFilters?.cap_material ? { cap_material: serverFilters.cap_material } : {}),
    ...(serverFilters?.sub_type ? { sub_type: serverFilters.sub_type } : {}),
    ...(serverFilters?.color ? { color: serverFilters.color } : {}),
  });

  const { data: filterOptions } = useFetchInventoryFilterOptionsQuery({
    type: "CAP MATERIAL",
  });
  
  // Handle paginated response structure (Django REST Framework returns {count, results, next, previous})
  // or non-paginated array response
  const new_data = Array.isArray(dataSource) ? dataSource : (dataSource?.results || []);
  const totalCount = dataSource?.count || (Array.isArray(dataSource) ? dataSource.length : 0);
  // filter((item)=>item?.color_cloth.cap_material!=="BUTTON"&&item?.color_cloth.cap_material!=="SWEATE BAND"&&item?.color_cloth.cap_material!=="PIPING"&&item?.color_cloth.cap_material!=="BUCKLE BELT"&&item?.color_cloth.cap_material!=="BACK CLOSER")
  const uniqueColors = (filterOptions?.colors?.length ? filterOptions.colors : [...new Set(new_data.map(item => item?.color_cloth?.color))]).filter((it)=>it!==null);
  const codeArry = (filterOptions?.color_codes?.length ? filterOptions.color_codes : [...new Set(new_data.map(item => item?.color_cloth?.color_code))]).filter((it)=>it!==null);
  const matType = (filterOptions?.cap_materials?.length ? filterOptions.cap_materials : [...new Set(new_data.map(item => item?.color_cloth?.cap_material))]).filter((it)=>it!==null);
  // const mat_sub_type = [...new Set(dataSource?.map(item => item?.color_cloth?.type).filter((it)=>it.type!==null))];
  const mat_sub_type = (filterOptions?.sub_types?.length ? filterOptions.sub_types : [...new Set(new_data.map(item => item?.color_cloth?.type))]).filter((it)=>it!==null);
  
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      // render: (text, record, index) => index + 1,
      // sorter: (a, b) => parseInt(a.id) - parseInt(b.id),
    },
    // {
    //   title: "Color Code",
    //   dataIndex: ["color_cloth", "color_code"],
    //   filters: codeArry.map(client => ({
    //     text: client,
    //     value: client,
    //   })),
    //   onFilter: (value, record) => record.color_cloth.color_code === value.toUpperCase(),
    //   filterSearch: true,
    // },
    {
      title: "Material Type",
      key: "cap_material",
      dataIndex: ["color_cloth", "cap_material"],
      filters: matType.map(client => ({
        text: client,
        value: client,
      })),
      filterSearch: true,
    },
    {
      title: "type",
      key: "sub_type",
      dataIndex: ["color_cloth", "type"],
      filters: mat_sub_type.map(client => ({
        text: client,
        value: client,
      })),
      filterSearch: true,
    },
    {
      title: "Color",
      key: "color",
      dataIndex: ["color_cloth", "color"],
      filters: uniqueColors.map(client => ({
        text: client,
        value: client,
      })),
      filterSearch: true,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: "15%",
      editable: true,
    },
  ];
  const material = "Edit Material"

  const handleTableChange = (_pagination, filters) => {
    const nextFilters = {
      cap_material:
        Array.isArray(filters?.cap_material) && filters.cap_material.length
          ? filters.cap_material[0]
          : null,
      sub_type:
        Array.isArray(filters?.sub_type) && filters.sub_type.length
          ? filters.sub_type[0]
          : null,
      color:
        Array.isArray(filters?.color) && filters.color.length ? filters.color[0] : null,
    };

    setServerFilters((prev) => {
      const prevNorm = prev || { cap_material: null, sub_type: null, color: null };
      const changed =
        prevNorm.cap_material !== nextFilters.cap_material ||
        prevNorm.sub_type !== nextFilters.sub_type ||
        prevNorm.color !== nextFilters.color;

      if (!changed) return prev;

      if (typeof onPaginationChange === "function") {
        onPaginationChange(1, pageSize);
      }

      return nextFilters;
    });
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
    <TableTitleStyles>Material</TableTitleStyles>
      <EditableTable 
        loading={loading} 
        material={material} 
        columns={columns} 
        dataSource={new_data}
        onTableChange={handleTableChange}
        onActivityLogClick={onActivityLogClick}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalCount,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
          onChange: (page, size) => {
            onPaginationChange(page, size);
          },
          onShowSizeChange: (current, size) => {
            onPaginationChange(1, size);
          },
        }}
      />
    </div>
  );
};

export default CapMaterialsTable;
